import React, {useEffect, useState} from 'react';
import {Button, Card, message} from "antd";
import dayjs from "dayjs";
import {useNavigate} from "react-router-dom";
import Cookies from "js-cookie";


const Home_soft_download=()=>{




    document.title='下载';


    const navigate=useNavigate();

    let data_time=dayjs().unix();


    useEffect(() => {


        sethome_fetch_software_info_select_log({message:'12',value:'',time:data_time})

    }, []);

    const [home_fetch_software_info_select_info, sethome_fetch_software_info_select_info] = useState({value1: '', value2: '', value3: '', time: 0})

    const [home_fetch_software_info_select_log, sethome_fetch_software_info_select_log] = useState({message: '', value: '', time: 0})
    const home_fetch_software_info = (e1: any) => {

        sethome_fetch_software_info_select_log({message: 'click', value: '', time: data_time})



        sethome_fetch_software_info_select_info({value1: e1, value2: '', value3: '', time: data_time})
    }


    const [return_data_home_fetch_software_info,setreturn_data_home_fetch_software_info]=useState({
        "message": 0,
        "value": "获取成功",
        "info": {
            "id": "8",
            "uuid": "ad46a853-2f24-415f-8283-74c8e4967046",
            "soft_name": "21",
            "soft_ver": "66",
            "soft_ver_update_info": "66",
            "soft_file_patch": "https://api.chatv2.leytcn.com/soft_file/1734002482_12.rar",
            "created": 0,
            "status": "en",
            "is_show": "1"
        }
    });

    const home_fetch_software_info_body = new FormData();


    home_fetch_software_info_body.append('id', home_fetch_software_info_select_info.value1);


    home_fetch_software_info_body.append('time', String(home_fetch_software_info_select_info.time));

    home_fetch_software_info_body.append('action', 'fetch_node');



    useEffect(() => {


        const data_async = async () => {


            const data_await = await fetch('https://api.chatv2.leytcn.com/home/software_d/fetch/fetch_show_soft_down.php', {


                method: 'POST',
                body: home_fetch_software_info_body

            })


            const return_data = await data_await.json();


            switch (return_data.message) {


                case 2000:

//获取消息，无需提示
               /*     message.success(return_data.value)*/
                    let data_time = dayjs().unix();

                    setreturn_data_home_fetch_software_info(return_data);

                 //   setfetch_fetch_project_select_log({message: '删除成功', value: '', time: data_time})

                    break

                case 2001:

                    message.error(return_data.value)


                    break


                case 4018:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/home_soft_download')


                    break

                case 4019:

                    setTimeout(() => {

                        /*      setbug_post_finish_button_loading(false);*/
                        message.error(return_data.value)
                    }, 300)

                    navigate('/login?return_url=/home_soft_download')


                    break


            }

        }


        if(home_fetch_software_info_select_log.message!==''){

            data_async();
            sethome_fetch_software_info_select_log({message:'',value:'',time:0})
        }
    }, [home_fetch_software_info_select_log]);




    return( <div  style={{minHeight:1500,background:'#fff'}}>



        <Card >


            {return_data_home_fetch_software_info.message!==2000?<div></div>:   <div style={{display:'flex'}}>

                <div style={{flexGrow:1}}>

                    <label>软件名：{return_data_home_fetch_software_info.info.soft_name}</label>
                    <p></p>
                    <label>版本号：{return_data_home_fetch_software_info.info.soft_ver}</label>
                    <p></p>
                    <label>发布时间：{dayjs.unix(return_data_home_fetch_software_info.info.created).format('YYYY-MM-DD HH:mm:ss')}</label>
                </div>



                <div>
                    <a href={return_data_home_fetch_software_info.info.soft_file_patch}>下载</a>
                </div>
            </div>}



        </Card>




    </div>)




}

export  default Home_soft_download
